import Axios from 'axios';
import {
  IAddon,
  IAutomessageFilter,
  IClean,
  IMeterFilter,
  IObject,
  IPageParam,
  IPoint,
  IRent,
  IRentFilter,
  ITaskFilter,
  ITemplate,
  ITip,
  IUpdate,
  IWappiGetChatsResponse,
  IWappiGetMessagesResponse,
  IWhatsapp,
} from './types';
import dayjs, { Dayjs } from 'dayjs';
import { notification } from 'antd';

export const FRONTEND_URL =
  process.env.REACT_APP_FRONTEND_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://crm.realtycalendar.ru');
export const CLIENT_URL =
  process.env.REACT_APP_CLIENT_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : 'https://crm.realtycalendar.ru');
export const URL =
  process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:5585' : 'https://crm.realtycalendar.ru');

export const axios = Axios.create({
  baseURL: `${URL}/api/admin`,
});

// export interface IItem {
//   id: string;
//   name: string;
//   description: string;
//   content: string;
//   user_count: string;
// }

// export interface IHistory {
//   id: number;
//   user_id: string;
//   event: string;
//   data: string;
// }

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // config.headers.Authorization = `Bearer Jr6%9TEc5Km6muzJ7Gk@Lznx7`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      window.location.href = '/login';
    } else if (error.response.data.message) {
      notification.error({
        message: 'Ошибка',
        description: error.response.data.message,
      });

      return error;
    } else {
      notification.error({
        message: 'Ошибка сети',
        description: 'Не удалось отправить запрос на сервер',
      });
    }
  },
);

export const API = {
  async login(dto: any) {
    try {
      const { data } = await axios.post<any>('agency/login', dto);
      return data;
    } catch (error) {
      console.log(' error:', error);
    }
  },
  subscriptions: {
    async saveSubscription(dto: PushSubscription) {
      try {
        const { data } = await axios.post<any>('push_subscriptions', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async notifySelf(dto: any) {
      try {
        const { data } = await axios.post<any>('push_subscriptions/notify_self', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  alerts: {
    async getAlerts() {
      try {
        const { data } = await axios.get<{ id: string; type: string; data: Record<string, any> }[]>('alerts');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async alertAction(alertId: number | string) {
      try {
        const { data } = await axios.post<any>('alerts/' + alertId + '/action');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  files: {
    async getFiles() {
      try {
        const { data } = await axios.get<any>('files');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addFile(dto: any) {
      try {
        const { data } = await axios.post<any>('files', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async deleteFile(id: any) {
      try {
        const { data } = await axios.delete<any>('files/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  settings: {
    async getSettings() {
      try {
        const { data } = await axios.get<any>('agency');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getAutomessages() {
      try {
        const { data } = await axios.get<IWhatsapp>('agency/automessages');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addAutomessages(dto: any) {
      try {
        const { data } = await axios.post<any>('agency/automessages', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async editAutomessageProfiles(dto: any) {
      try {
        const { data } = await axios.patch<any>(`agency/automessages/profiles/${dto.id}`, dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async checkAutomessages(dto: any) {
      try {
        const { data } = await axios.post<any>('agency/automessages/check', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async registerWebhook(id: number) {
      try {
        const result = await axios.post<any>(`agency/automessages/profiles/${id}/register_webhook`);

        if (result.status === 200) {
          notification.success({
            message: 'Вебхук зарегистрирован',
          });
        }

        return result.data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async checkProfile(id: number) {
      try {
        const result = await axios.post<any>(`agency/automessages/profiles/${id}/check`);

        return result.data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getInvoices() {
      try {
        const { data } = await axios.get<any>('agency/invoices');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getQrCode() {
      try {
        const { data } = await axios.get<any>('agency/settings/qr_code');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async uploadQrCode(formData: any, setProgress?: Function) {
      try {
        const { data } = await axios.post('agency/settings/qr_code', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            const { progress } = progressEvent;

            progress && setProgress && setProgress((progress * 100).toFixed(0));
          },
        });

        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async uploadKeyboxVideo(formData: any, setProgress?: Function) {
      try {
        const { data } = await axios.post('agency/settings/keybox_video', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            const { progress } = progressEvent;

            progress && setProgress && setProgress((progress * 100).toFixed(0));
          },
        });

        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeSettings(dto: any) {
      try {
        const { data } = await axios.patch<any>('agency/settings', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async checkHooks() {
      try {
        const { data } = await axios.get<any>('agency/hooks');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addHooks() {
      try {
        const { data } = await axios.post<any>('agency/hooks');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async integrateRealtyAutomessages() {
      try {
        const { data } = await axios.post<any>('agency/integrate_realty_automessages');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async enableTrial() {
      try {
        const { data } = await axios.post<any>('agency/enable_trial');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async createTestTopic() {
      try {
        const { data } = await axios.post<any>('agency/topic');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getCleanCommonInstruction() {
      try {
        const { data } = await axios.get<any>('agency/cleaninstruction');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getCleanSettings() {
      try {
        const { data } = await axios.get<any>('agency/clean_settings');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeCleanersSettings(dto: any) {
      try {
        const { data } = await axios.patch<any>('agency/clean_settings', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addCleanCommonInstruction(dto: any) {
      try {
        const { data } = await axios.post<any>('agency/cleaninstruction', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeCleanCommonInstruction(dto: any) {
      try {
        const { data } = await axios.patch<any>('agency/cleaninstruction', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },

    async changePassword(dto: any) {
      try {
        const { data } = await axios.post<any>('users/changepassword', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getPersonalTemplate() {
      try {
        const { data } = await axios.get<any>('agency/personal');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeOkiDokiSettings(dto: { integration_enabled: boolean; contract_creation_enabled: boolean }) {
      try {
        const { data } = await axios.post('agency/settings/okidoki', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  constants: {
    async getSources() {
      try {
        const { data } = await axios.get<any>('agency/sources');
        return data.data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  agency: {
    async getSettings() {
      try {
        const { data } = await axios.get<any>('agency');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getOnboarding() {
      try {
        const { data } = await axios.get('agency/onboarding');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  checks: {
    async checkBots() {
      try {
        const { data } = await axios.get<any>('agency/bots');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async checkMoneta() {
      try {
        const { data } = await axios.get<{
          deposit_from_payment_system_allowed: boolean;
          deposit_balance?: number | `${number}` | null;
        }>('agency/check_moneta');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async checkHowin() {
      try {
        const { data } = await axios.get<
          {
            id: number;
            name: string;
          }[]
        >('objects/check_howin');

        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async checkSettingsQrCode() {
      try {
        const { data } = await axios.get<any>('agency/settings/check_qr_code');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async checkObjectsQrCodes() {
      try {
        const { data } = await axios.get<any>('objects/check_qr_codes');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  messages: {
    async getMessages() {
      try {
        const { data } = await axios.get<any>('messages');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addMessage(dto: { name: string; text: string }) {
      try {
        const { data } = await axios.post('messages', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeMessage(dto: { id: any; name: string; text: string }) {
      try {
        const { data } = await axios.patch('messages', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async deleteMessage(id: any) {
      try {
        const { data } = await axios.delete('messages/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  papertrails: {
    async getPapertrails(filters: IAutomessageFilter | null, page = 1) {
      try {
        const { data } = await axios.get<any>('papertrails', {
          params: {
            ...filters,
            page,
          },
        });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  meters: {
    async uploadPhoto(formData: any, setProgress?: Function) {
      try {
        const { data } = await axios.post('meters/photos', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            const { progress } = progressEvent;

            progress && setProgress && setProgress((progress * 100).toFixed(0));
          },
        });

        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getReadings(filters: IMeterFilter | null, page = 1) {
      try {
        const { data } = await axios.get<any>('meters/readings', {
          params: {
            ...filters,
            page,
          },
        });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async requestReadings(object_id: number) {
      try {
        const result = await axios.post<any>('meters/request_readings', {
          object_id,
        });

        if (result.status === 200) {
          notification.success({
            message: 'Запрос отправлен',
          });
        }

        return result.data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async saveReadings({
      object_id,
      ...values
    }: {
      object_id: number;
      cold_water: number;
      hot_water: number;
      electricity: number;
      electricity_day: number;
      electricity_night: number;
      gas: number;
      paid: boolean;
      photos: string[];
    }) {
      try {
        const result = await axios.post<any>(`meters/${object_id}`, values);

        if (result.status === 200) {
          notification.success({
            message: 'Показания отправлены',
          });
        }

        return result.data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async updateReadings({
      id,
      ...values
    }: {
      id: number;
      cold_water: number;
      hot_water: number;
      electricity: number;
      electricity_day: number;
      electricity_night: number;
      gas: number;
      paid: boolean;
      photos: string[];
      object_id: number;
    }) {
      try {
        const result = await axios.patch<any>(`meters/${id}`, values);

        if (result.status === 200) {
          notification.success({
            message: 'Показания обновлены',
          });
        }

        return result.data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  automessages: {
    async getChat(filters: { chat_id: string }, page = 1) {
      try {
        const { chat_id, ...params } = filters;
        const { data } = await axios.get<any>(`automessages/chats/${chat_id}`, {
          params: {
            ...params,
            page,
          },
        });

        return data as IWappiGetMessagesResponse;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getChatList(page = 1) {
      try {
        const { data } = await axios.get<any>(`automessages/chats`, {
          params: {
            page,
          },
        });

        return data as IWappiGetChatsResponse;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getMessages(filters: IAutomessageFilter | null, page = 1) {
      try {
        const { data } = await axios.get<any>('automessages', {
          params: {
            ...filters,
            page,
          },
        });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async checkStatus(id: number) {
      try {
        const result = await axios.post<any>(`automessages/${id}/check_status`);

        if (result.status === 200) {
          notification.success({
            message: 'Статус обновлен',
          });
        }

        return result.data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async resendMessage(id: number) {
      try {
        const { data } = await axios.post<any>(`automessages/${id}/resend`);

        notification.success({
          message: 'Сообщение отправлено',
        });

        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  objects: {
    async getUnloadedObjectsCount() {
      try {
        const {
          data: { count },
        } = await axios.get(`objects/unloaded`);
        return count;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getObjects(showArchived = false, forSelect?: boolean) {
      try {
        const params = {
          showArchived: showArchived ? showArchived : undefined,
          forSelect: forSelect ? forSelect : undefined,
        };
        const { data } = await axios.get<IObject[]>('objects', {
          params,
        });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getObjectsForSelect() {
      try {
        const { data } = await axios.get<any[]>('objects/select');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async loadObjects(timezone: any) {
      try {
        const { data } = await axios.post<any>('objects/load', { timezone });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getObject(id: any) {
      try {
        const { data } = await axios.get<IObject>('objects/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getQrCode(id: number | string) {
      try {
        const { data } = await axios.get<any>(`objects/${id}/qr_code`);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async deleteQrCode(id: number | string) {
      try {
        await axios.delete(`objects/${id}/qr_code`);
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async uploadQrCode(id: number | string, formData: any, setProgress?: Function) {
      try {
        const { data } = await axios.post(`objects/${id}/qr_code`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            const { progress } = progressEvent;

            progress && setProgress && setProgress((progress * 100).toFixed(0));
          },
        });

        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeObject(dto: any) {
      try {
        const { data } = await axios.patch('objects', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeObjectInstructions(dto: any) {
      try {
        const { data } = await axios.patch('objects/instructions', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async activeAllObjects(dto: any) {
      try {
        const { data } = await axios.patch('objects/activeall', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getInstructionsExamples() {
      try {
        const { data } = await axios.get('objects/instructions/examples');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getInstructionsFromOtherObject(type: string) {
      try {
        const { data } = await axios.get('objects/instructions/other/' + type);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async insertInstructionToAllObjects(type: string, text: string, show: string, object_id: any) {
      try {
        const { data } = await axios.patch('objects/instructions/all', { type, object_id, text, show });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  points: {
    async getPoints(id: any) {
      try {
        const { data } = await axios.get<IPoint[]>('points/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addPoint(dto: { name: string; desc: string; object_id: any }) {
      try {
        const { data } = await axios.post('points', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changePoint(dto: { name: string; desc: string; id: any }) {
      try {
        const { data } = await axios.patch('points', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async upPoint(dto: { index: number; id: any; object_id: any }) {
      try {
        const { data } = await axios.patch('points/up', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async deletePoint(id: number) {
      try {
        const { data } = await axios.delete('points/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  instructions: {
    async getInstruction(id: any) {
      try {
        const { data } = await axios.get('objects/instruction/' + id);
        return data;
      } catch (error: any) {
        throw new Error('Ошибка при получении данных: ' + error.message);
      }
    },
    async addInstruction(dto: any) {
      try {
        const { data } = await axios.post<IObject>('objects/instruction/', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async editInstruction(dto: any) {
      try {
        const { data } = await axios.patch<IObject>('objects/instruction/', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  templates: {
    async getTemplates() {
      try {
        const { data } = await axios.get<ITemplate[]>('templates');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getTemplatesOptions() {
      try {
        const { data } = await axios.get<any[]>('templates/options');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addTemplate(dto: { name: string; text: string }) {
      try {
        const { data } = await axios.post('templates', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeTemplate(dto: { id: number; name: string; text: string }) {
      try {
        const { data } = await axios.patch('templates', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async deleteTemplate(id: number) {
      try {
        const { data } = await axios.delete('templates/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addTemplateToPoints(id: number) {
      try {
        const { data } = await axios.patch('templates/bulk', { id });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  addons: {
    async getAddons(id: any) {
      try {
        const { data } = await axios.get<IAddon[]>('addons/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addAddon(dto: { name: string; desc: string; object_id: any }) {
      try {
        const { data } = await axios.post('addons', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeAddon(dto: { name: string; desc: string; id: any }) {
      try {
        const { data } = await axios.patch('addons', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async deleteAddon(id: any) {
      try {
        const { data } = await axios.delete('addons/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },

  async getRents(params: IRentFilter & IPageParam) {
    const { status_changed_at } = params;

    try {
      const { data } = await axios.get<{ rents: IRent[]; total: number }>('rents', {
        params: {
          ...params,
          status_changed_at_begin: status_changed_at?.begin,
          status_changed_at_end: status_changed_at?.end,
        },
      });
      return data;
    } catch (error) {
      console.log(' error:', error);
    }
  },

  async getRentPhones() {
    try {
      const { data } = await axios.get<Pick<IRent, 'phone'>[]>('rents/phones');
      return data;
    } catch (error) {
      console.log(' error:', error);
    }
  },

  updates: {
    async getUpdates() {
      try {
        const { data } = await axios.get<IUpdate[]>('updates');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getUnseenUpdatesCount() {
      try {
        const {
          data: { count },
        } = await axios.get(`updates/unseen`);
        return count;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  cleans: {
    async getCleans(dto: any) {
      const { begin, end, cleaner_id, object_id, status } = dto;
      try {
        let url = `cleans?begin=${dayjs(begin).format('YYYY-MM-DD')}&end=${dayjs(end).format('YYYY-MM-DD')}`;
        if (cleaner_id) {
          url = url + `&cleaner_id=${cleaner_id}`;
        }
        if (object_id) {
          url = url + `&object_id=${object_id}`;
        }
        if (status) {
          url = url + `&status=${status}`;
        }
        const { data } = await axios.get<{ cleans: IClean[]; amount: number; count: number; sum: number }>(url);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getReport({ begin, end }: { begin: Dayjs; end: Dayjs }) {
      try {
        const { data } = await axios.get<
          { cleaner_name: string; total_cleans: string; total_cost: string; rates_count: string; avg_rate: string }[]
        >('cleans/report', {
          params: {
            begin: begin.format('YYYY-MM-DD'),
            end: end.format('YYYY-MM-DD'),
          },
        });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addClean(dto: any) {
      try {
        const { data } = await axios.post('cleans', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getExport() {
      try {
        const { data } = await axios.get('cleans/export', {
          responseType: 'blob',
        });

        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getUnassignedCleansCount(dto: any) {
      try {
        const { data } = await axios.get('cleans/unassigned');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeClean(dto: any) {
      return axios.patch('cleans', dto);
    },
    // async addCleanerToRent(dto: any) {
    //   try {
    //     const { data } = await axios.patch("cleans/add", dto);
    //     return data;
    //   } catch (error) {
    //     console.log(" error:", error);
    //   }
    // },
    async getClean(id: any) {
      try {
        const { data } = await axios.get('cleans/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  dashboard: {
    async getStatistics(dto: any) {
      const { begin, end } = dto;
      try {
        const url = `dashboard/statistics?begin=${dayjs(begin).format('YYYY-MM-DD')}&end=${dayjs(end).format(
          'YYYY-MM-DD',
        )}`;
        const { data } = await axios.get<any>(url);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getDashboard() {
      try {
        const { data } = await axios.get<any>('dashboard');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  clienttasks: {
    async getClientTasks(filter: {
      rent_id?: any;
      status?: string;
      begin?: Dayjs;
      end?: Dayjs;
      page?: number;
      pageSize?: number;
    }) {
      const { rent_id, ...params } = filter;

      try {
        const { data } = await axios.get<{ total: number; items: any[] }>(
          rent_id ? `clienttasks/${rent_id}` : `clienttasks`,
          {
            params,
          },
        );
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getClientTasksCount() {
      try {
        const {
          data: { count },
        } = await axios.get(`clienttasks/count`);
        return count;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async submitClientTask(dto: { id: any; status: 'confirm' | 'cancel' }) {
      try {
        const { data } = await axios.patch<any>(`clienttasks`, dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async deleteClientTask(dto: { id: any }) {
      try {
        const { data } = await axios.delete<any>(`clienttasks/${dto.id}`);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async restoreClientTask(dto: { id: any }) {
      try {
        const { data } = await axios.patch<any>(`clienttasks/${dto.id}/restore`);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  history: {
    async deleteHistory(dto: { name: string; rent_id: number }) {
      try {
        const { data } = await axios.patch('history/delete_payment', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addHistory(dto: { name: string; rent_id: number; user_id?: string; data?: any }) {
      try {
        const { data } = await axios.post('history', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async removeHistory(id: number) {
      try {
        return axios.delete('history/' + id);
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },

  async getSteps() {
    try {
      const { data } = await axios.get<any[]>('steps');
      return data;
    } catch (error) {
      console.log(' error:', error);
    }
  },
  async changeStep(dto: { id: number; heading?: string; text?: string; index?: number }) {
    try {
      const { data } = await axios.patch<any[]>('steps', dto);
      return data;
    } catch (error) {
      console.log(' error:', error);
    }
  },
  async deleteStep(id: number) {
    try {
      const { data } = await axios.delete('steps/' + id);
      return data;
    } catch (error) {
      console.log(' error:', error);
    }
  },
  otas: {
    async getOtas() {
      try {
        const { data } = await axios.get<any[]>('agency/otas');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addOta(dto: any) {
      try {
        const { data } = await axios.post('agency/otas', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async editOta(dto: any) {
      try {
        const { data } = await axios.patch('agency/otas', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  cleaners: {
    async getCleaners() {
      try {
        const { data } = await axios.get<any[]>('cleaners');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async deleteCleaner(id: any) {
      try {
        const { data } = await axios.delete('cleaners/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async activateCleaner(id: any) {
      try {
        const { data } = await axios.patch('cleaners', { id, active: true });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getCleansByCleanerId(dto: any) {
      try {
        const { data } = await axios.get<{ cleans: IClean[]; amount: number; count: number; name: string }>(
          `cleaners/${dto.id}?begin=${dayjs(dto.begin).format('YYYY-MM-DD')}&end=${dayjs(dto.end).format('YYYY-MM-DD')}`,
        );
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addCleaner(dto: any) {
      try {
        const { data } = await axios.post('cleaners', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addObjectToCleaner(dto: any) {
      try {
        const { data } = await axios.post('cleaners/object', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async deleteObjectFromCleaner(dto: any) {
      try {
        const { data } = await axios.patch('cleaners/object/delete', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async editCostOfCleanerObject(dto: any) {
      try {
        const { data } = await axios.patch('cleaners/object', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeCleaner(dto: any) {
      try {
        const { data } = await axios.patch('cleaners', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async appointCleanerToCleans(dto: any) {
      try {
        const { data } = await axios.patch('cleaners/appoint', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  rents: {
    async changeRent(dto: any) {
      try {
        const { data } = await axios.patch('rents', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async createTopic(rent_id: any) {
      try {
        const { data } = await axios.patch('rents/createtopic', { rent_id });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getRent(id: any) {
      try {
        const { data } = await axios.get('rents/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getRentByPhone(phone: string) {
      try {
        const { data } = await axios.get('rents/by_phone/' + phone);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async refreshRents() {
      try {
        const { data } = await axios.post('rents/refresh');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async refreshRent(rendId: string | number) {
      try {
        await axios.post(`rents/refresh/${rendId}`);
        return true;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addPayment(dto: { amount: any; object_id: any; rent_id: any }) {
      try {
        const { data } = await axios.post('rents/payment', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async cancelGuestOut(rent_id: string | number) {
      try {
        await axios.post(`rents/cancel_guest_out/${rent_id}`);
        return true;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  tasks: {
    async getTasks(filters: ITaskFilter | null, page = 1) {
      try {
        const { data } = await axios.get<any>('tasks', {
          params: {
            ...filters,
            page,
          },
        });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getShoppingList(type: string) {
      try {
        const { data } = await axios.get<any>('tasks/shopping_list', {
          params: {
            type,
          },
        });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeTask(dto: any) {
      try {
        const { data } = await axios.patch<any[]>('tasks', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addTask(dto: any) {
      try {
        const { data } = await axios.post<any[]>('tasks', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  owners: {
    async getOwners() {
      try {
        const { data } = await axios.get<any[]>('owners');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addOwner(dto: any) {
      try {
        const { data } = await axios.post('owners', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeOwner(dto: any) {
      try {
        const { data } = await axios.patch('owners', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async deleteOwner(id: any) {
      try {
        const { data } = await axios.delete('owners/' + id);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async getRentsByOwnerId(dto: any) {
      try {
        const { data } = await axios.get<any>(
          `owners/rents/${dto.id}?begin=${dayjs(dto.begin).format('YYYY-MM-DD')}&end=${dayjs(dto.end).format(
            'YYYY-MM-DD',
          )}`,
        );
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  tips: {
    async getTip() {
      try {
        const { data } = await axios.get<ITip>('tips');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  users: {
    async getUsers(status?: 'active' | 'inactive') {
      try {
        const { data } = await axios.get<any[]>('users', { params: { status } });
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async addUser(dto: any) {
      try {
        const { data } = await axios.post('users/new', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async checkUser() {
      try {
        const { data } = await axios.post('users/info');
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async login(dto: any) {
      try {
        const { data } = await axios.post<any>('users/login', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
    async changeUser(dto: any) {
      try {
        const { data } = await axios.patch('users', dto);
        return data;
      } catch (error) {
        console.log(' error:', error);
      }
    },
  },
  async loadRentsFromRC() {
    try {
      const { data } = await axios.post('rents/fetch');
      return data;
    } catch (error) {
      console.log(' error:', error);
    }
  },
};
